import { AuditFormSectionDto } from './auditFormSection.dto';
import { AuditFormStatusDto } from './auditFormStatus.dto';
import { BaseDto } from '../base.dto';
import { MerchantDto } from '../merchant.dto';

export class AuditFormDto extends BaseDto {
  name: string;
  description?: string;
  passingScore?: number;
  isDeleted?: boolean;
  activeQuestionTotal?: number;
  auditFormStatus: AuditFormStatusDto;
  merchants: MerchantDto[];
  firstCompleted?: Date;
  lastCompleted?: Date;
  totalCompletions?: number;
  averageScore?: number;
  merchantsAll?: MerchantDto[];
  sections?: AuditFormSectionDto[];
}
